var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3917 10.941C27.7922 11.3416 27.7922 11.991 27.3917 12.3915L20.725 19.0582C20.3245 19.4587 19.6751 19.4587 19.2745 19.0582C18.874 18.6576 18.874 18.0082 19.2745 17.6077L25.9412 10.941C26.3417 10.5405 26.9911 10.5405 27.3917 10.941ZM37.3917 10.941C37.7922 11.3416 37.7922 11.991 37.3917 12.3915L21.4322 28.351C20.641 29.1422 19.3586 29.1422 18.5674 28.351L14.9998 24.7834L11.4322 28.3509C11.4322 28.3509 11.4321 28.351 11.4321 28.351C10.641 29.1422 9.35848 29.1422 8.56743 28.351C8.56738 28.351 8.56733 28.3509 8.56729 28.3509L1.77453 21.5582C1.37399 21.1576 1.37399 20.5082 1.77452 20.1077C2.17506 19.7072 2.82446 19.7072 3.225 20.1077L9.99976 26.8824L13.5493 23.3329L10.9412 20.7248C10.5407 20.3243 10.5407 19.6749 10.9412 19.2744C11.3417 18.8738 11.9911 18.8738 12.3917 19.2744L15.7241 22.6068C15.7244 22.6071 15.7247 22.6074 15.725 22.6077C15.7253 22.608 15.7256 22.6083 15.7259 22.6085L19.9998 26.8825L35.9412 10.941C36.3417 10.5405 36.9911 10.5405 37.3917 10.941Z",
    fill: "#6833FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.5e40eb27f293c58ccac709f78fa8f237.svg";
export { ForwardRef as ReactComponent };